import { render, staticRenderFns } from "./ToggleClientDropdown.vue?vue&type=template&id=38c2f031&scoped=true"
import script from "./ToggleClientDropdown.vue?vue&type=script&lang=js"
export * from "./ToggleClientDropdown.vue?vue&type=script&lang=js"
import style0 from "./ToggleClientDropdown.vue?vue&type=style&index=0&id=38c2f031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2f031",
  null
  
)

export default component.exports